import firebase from "firebase/app";
import type {
  LlmUsageLimits,
  LlmUsageLimitEntry,
  LlmUsageLimitValue
} from "@/entities/llm_usage_limit";

export async function getLlmUsageLimits(): Promise<LlmUsageLimits> {
  const call = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("get_llm_usage_limits");
  const res = await call();
  return res.data.limits;
}

export async function setSchoolLlmUsageLimit(input: {
  schoolId: string;
  limit: LlmUsageLimitValue;
  effectiveFrom?: number;
  reason: string;
}): Promise<LlmUsageLimitEntry[]> {
  const call = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("set_school_llm_usage_limit");
  const res = await call(input);
  return res.data.llmUsageLimits;
}

export async function cancelSchoolLlmUsageLimit(input: {
  schoolId: string;
  effectiveFrom: number;
}): Promise<LlmUsageLimitEntry[]> {
  const call = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("cancel_school_llm_usage_limit");
  const res = await call(input);
  return res.data.llmUsageLimits;
}
